import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type { SavedView } from './types';
import {
  getSavedViewsListQueryKey,
  GetSavedViewsListQueryKeyType,
} from './utils';

export const useGetSavedViews: QueryFunction<
  SavedView[],
  [],
  GetSavedViewsListQueryKeyType
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getSavedViewsListQueryKey(),
    queryFn: ({ signal }) => {
      return request<SavedView[]>(`/display_configs/views`, {
        init: {
          method: 'GET',
          signal,
        },
      });
    },
  });
};
